import api, { createApiService } from "../http";
import { ICompoundSubjectRights } from "../types/services-types/subject-rights-types";

export default class CompoundSubjectRightsService {

    static apiCompoundSubjectRightsService = createApiService('/compound-subject-rights')


    static async Add(subject_rights_id: string | number, name: string, date: string, population: string | number, sum_budget: string | number) {
        const response = await this.apiCompoundSubjectRightsService.post<ICompoundSubjectRights>(`/create`, {
            subject_rights_id,
            name,
            date,
            population,
            sum_budget
        })
        return response.data
    }

    static async Get(id: number | string) {
        const response = await this.apiCompoundSubjectRightsService.get<ICompoundSubjectRights>(`/${id}`)
        return response.data
    }

    static async GetAll(limit = 100, page = 0) {
        const response = await this.apiCompoundSubjectRightsService.get<ICompoundSubjectRights[]>(`/all`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async Remove(id: number | string) {
        const response = await this.apiCompoundSubjectRightsService.get<number>(`/remove/${id}`)
        return response.data
    }

    static async Update(id: number | string, subject_rights_id: number | string, name: string, date: string, population: string | number, sum_budget: string | number) {
        const response = await this.apiCompoundSubjectRightsService.post<ICompoundSubjectRights>(`/update`, {
            id,
            subject_rights_id,
            name,
            date,
            population,
            sum_budget
        })
        return response.data
    }
}